import { FunctionComponent } from "react";

import { Separator, Stack } from "@bps/fluent-ui";
import { QueryStateIndicator } from "@components/QueryStateIndicator";
import { usePermissionsCheckQuery } from "@libs/api/gateways/env/env-gateway.hooks";
import {
  useTenantDefaultUserAuth,
  useUserDefaultAuth,
  useUserNetworkAuthenticationSettings
} from "@libs/api/gateways/plt/plt-gateway.hooks";
import { Permissions } from "@libs/permissions/permissions.enum";

import { UserGlobalNetworkRestrictionsSection } from "./UserGlobalNetworkRestrictionsSection";
import { UserIpRangesSection } from "./UserIpRangesSection";

interface UserNetworkingSectionProps {
  tenantId: string;
  userId: string;
}
export const UserNetworkingSection: FunctionComponent<UserNetworkingSectionProps> = ({
  userId,
  tenantId
}) => {
  const { data: hasWritePermission } = usePermissionsCheckQuery(
    Permissions.PltCatalogUserAuthenticationWrite
  );

  const tenatAuthSettingsQuery = useTenantDefaultUserAuth(tenantId);

  const networkSettingsQuery = useUserNetworkAuthenticationSettings(
    tenantId,
    userId
  );

  const authSettingsQuery = useUserDefaultAuth(tenantId, userId);

  return (
    <>
      <Separator />
      <QueryStateIndicator
        data={{
          tenantAuthSettings: tenatAuthSettingsQuery.data,
          networkSettings: networkSettingsQuery.data,
          authSettings: authSettingsQuery.data
        }}
        allowNullOrUndefined
        isLoading={
          networkSettingsQuery.isLoading || authSettingsQuery.isLoading
        }
        error={networkSettingsQuery.error ?? authSettingsQuery.error}
      >
        {({ tenantAuthSettings, networkSettings, authSettings }) => (
          <Stack tokens={{ childrenGap: 32 }}>
            <Stack>
              <UserGlobalNetworkRestrictionsSection
                tenantId={tenantId}
                userId={userId}
                tenantAuthSettings={tenantAuthSettings}
                networkSettings={networkSettings ?? []}
                authSettings={authSettings}
              />
            </Stack>
            <Stack>
              <UserIpRangesSection
                hasWritePermission={!!hasWritePermission}
                networkSettings={networkSettings ?? []}
                tenantId={tenantId}
                userId={userId}
              />
            </Stack>
          </Stack>
        )}
      </QueryStateIndicator>
    </>
  );
};
